import * as actionTypes from "../constants/actionTypes";

export function saveSearchCriteria(pageSearchCriteria) {
    return {type: actionTypes.SAVE_SEARCH_CRITERIA, pageSearchCriteria};
}

export function createSearchCriteria(pageSearchCriteria) {
    return {type: actionTypes.CREATE_SEARCH_CRITERIA, pageSearchCriteria};
}
